import React, { CSSProperties } from 'react';
import classnames from 'classnames';
import { DataRowFormatType, formatValue } from '@apply/ui';

export interface DataRowProps {
    value?: unknown;
    format?: DataRowFormatType;
    style?: React.CSSProperties;
    isSubheader?: boolean;
}

export const DataRow: React.FC<DataRowProps> = ({ children, value, format, style, isSubheader }) => {
    const localStyle: CSSProperties = {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingLeft: '20px',
        paddingRight: '20px',
        ...style,
    };
    return (
        <div
            className={classnames('row', { 'data-row-subheader': isSubheader })}
            style={localStyle}
        >
            <div style={{ width: '50%' }}>{children}</div>
            <div
                style={{
                    whiteSpace: 'pre-wrap',
                    width: '50%',
                    paddingLeft: 20,
                }}
            >
                {formatValue(value, format)}
            </div>
        </div>
    );
};

export const BannerDataRow: React.FC<DataRowProps> = ({ children, value, format, style, isSubheader }) => {
    const localStyle: CSSProperties = {
        boxSizing: 'content-box',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginLeft: '16px',
        marginRight: '16px',
        marginBottom: '5px',
        borderBottom: '2px solid #f14947',
        lineHeight: '1.4',
        ...style,
    };
    return (
        <div style={localStyle}>
            <div
                style={{
                    fontWeight: 600,
                    fontSize: '1.25rem',
                    color: '#2c5591',
                    width: '50%',
                }}
            >
                {children}
            </div>
            <div style={{ whiteSpace: 'pre-wrap', width: '50%' }}>{formatValue(value, format)}</div>
        </div>
    );
};
